/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp } from '../../../_metronic/helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import { ChannelFormDto } from '../widgets/ChannelForm';
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'
import FacebookLogin from '@greatsumini/react-facebook-login';
import { Schema } from 'inspector'

type Props = {
  functionSubmit?: any
}
const animatedComponents = makeAnimated();
const ChannelCreateModal: FC<Props> = ({ functionSubmit }) => {
  const createChannelSchema = Yup.object().shape({
    channelName: Yup.string()
      .min(3, LanguageHelp('Minimum 3 symbols'))
      .max(50, LanguageHelp('Maximum 50 symbols'))
      .required(LanguageHelp('Channel name is required')),
    competitorName: Yup.string().when('isCompetitor',
      (isCompetitor, schema) => {
        if (isCompetitor == true) {
          return schema
            .min(3, LanguageHelp('Minimum 3 symbols'))
            .max(50, LanguageHelp('Maximum 50 symbols'))
            .required(LanguageHelp('Competitor name is required'))
        } else {
          return schema;
        }
      }),
    type: Yup.string()
      .required(LanguageHelp('Channel type is required')),
    searchUrl: Yup.string().when('type',
      (type, schema) => {
        if (type == 3 || type == 5) { // 10:Sikayetvar, 5:Ekşi
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .url(LanguageHelp('The text you enter must be the url'))
            .required(LanguageHelp('Search url is required'))
        } else {
          return schema;
        }
      }),
    searchQuery: Yup.string().when('type',
      (type, schema) => {
        if (type == 8) { // 8:Youtube
          return schema.min(24, LanguageHelp('Must be exactly 24 digits')).max(24, LanguageHelp('Must be exactly 24 digits'))
            .required(LanguageHelp('Channel Id is required'))
        }
        else if (type == 9) { // 9:Reddit
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .max(21, LanguageHelp('Maximum 21 symbols'))
            .matches("^[a-zA-Z0-9_]*$", LanguageHelp("Subreddit name is wrong"))
            .required(LanguageHelp('Subreddit name is required'))
        }
        else if (type == 10) { // 10:Instagram_Comments
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-z0-9_.]*$", LanguageHelp("Your username can only contain lowercase letters, numbers, \".\" and \"_\""))
            .required(LanguageHelp('Instagram username is required'))
        }
        else if (type == 12) { // 12:TikTok_Comments
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-z0-9_.]*$", LanguageHelp("Your username can only contain lowercase letters, numbers, \".\" and \"_\""))
            .required(LanguageHelp('TikTok username is required'))
        }
        else {
          return schema;
        }
      }),
    searchQueryList: Yup.array().when('type',
      (type, schema) => {
        if (type == 2 || type == 9 || type == 11) { // 2:Twitter, 9:Reddit, 11:Instagram_Sharing
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
            // Rest of your amenities object properties
          }))
        }
        else if (type == 7) { // 7:Instagram_Comments
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols')).matches(/^#/, LanguageHelp("starts with #"))
            // Rest of your amenities object properties
          }))
        }
        else {
          return schema;
        }
      }),
    searchQueryExceptionList: Yup.array().when('type',
      (type, schema) => {
        if (type == 2) { // 2:Twitter
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
              .matches(/^[a-zA-Z0-9_.]*$/, LanguageHelp("Your username can only contain lowercase letters, uppercase letters, numbers, \".\" and \"_\""))
            // Rest of your amenities object properties
          }))
        }
        if (type == 7 || type == 11) { // 7:Instagram_Comments 11:Instagram_Sharing
          return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
            label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
              .matches(/^[a-z0-9_.]*$/, LanguageHelp("Your username can only contain lowercase letters, numbers, \".\" and \"_\""))
            // Rest of your amenities object properties
          }))
        }
        else {
          return schema;
        }
      }),
    expirationTime: Yup.string()
      .required(LanguageHelp('Expiration time is required')),
  })
  const [channelForCreate] = useState(new ChannelFormDto())
  const { mode } = useThemeMode()

  const formik = useFormik({
    initialValues: channelForCreate,
    validationSchema: createChannelSchema,
    onSubmit: async (values, { setSubmitting }) => {
      isSuccess = false
      try {
        var queryList: string[] = []
        values.searchQueryList.forEach(searchQuery => {
          queryList.push(Object(searchQuery)['label'])
        });
        var queryExceptionList: string[] = []
        values.searchQueryExceptionList.forEach(searchQueryException => {
          queryExceptionList.push(Object(searchQueryException)['label'])
        });
        var isSuccess = await functionSubmit("", values.channelName, values.companyId, values.searchQuery, values.type, values.searchUrl, values.isAutoSearch, queryList, queryExceptionList, values.expirationTime, values.isCompetitor, values.competitorName)
        console.log(isSuccess, "isSuccess")
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(true)
        document.getElementById("buttonCreateDismiss")?.click()
        if (isSuccess == true) {
          document.body.classList.remove('modal-open')
          formik.resetForm();
        }
      }
    },
  })

  return (
    <div className='modal fade' id='kt_modal_channel_create' aria-hidden='true'>
      <div className='modal-dialog modal-l'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Add Channel')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' id='buttonCreateDismiss' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Channel Type')}</label>
                  <div className='col-lg-8 fv-row'>
                    <select
                      className='form-select form-select-solid form-select-lg'
                      {...formik.getFieldProps('type')}
                      onChange={e => {
                        formik.handleChange(e);
                        if (e.currentTarget.value !== undefined && e.currentTarget.selectedOptions.length > 0) {
                          formik.setFieldValue('channelName', e.currentTarget.selectedOptions[0].text + ' - ')
                        }
                      }}
                    >
                      <option value='1'>{LanguageHelp('Api')}</option>
                      <option value='2'>{LanguageHelp('Twitter')}</option>
                      <option value='3'>{LanguageHelp('Şikayet Var')}</option>
                      <option value='5'>{LanguageHelp('Ekşi Sözlük')}</option>
                      <option value='6'>{LanguageHelp('IFrame')}</option>
                      <option value='7'>{LanguageHelp('Instagram Mentions')}</option>
                      <option value='10'>{LanguageHelp('Instagram Comments')}</option>
                      <option value='4'>{LanguageHelp('Facebook')}</option>
                      <option value='8'>{LanguageHelp('Youtube')}</option>
                      <option value='9'>{LanguageHelp('Reddit')}</option>
                      <option value='11'>{LanguageHelp('TikTok Mentions')}</option>
                      <option value='12'>{LanguageHelp('TikTok Comments')}</option>
                    </select>
                  </div>
                </div>

                {/* begin::Input group */}
                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Channel Name')}</label>
                    <div className='col-lg-8 fv-row'>
                      <input
                        placeholder={LanguageHelp('Channel Name')}
                        {...formik.getFieldProps('channelName')}
                        type='text'
                        name='channelName'
                        className={clsx('form-control form-control-lg form-control-solid')}
                        autoComplete='off'
                        disabled={formik.isSubmitting}
                      />
                      {formik.touched.channelName && formik.errors.channelName && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.channelName}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* end::Input group */}

                {(formik.values.type == 2) &&
                  <div>

                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked Twitter Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Texts to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.type == 4) &&
                  <div>
                    <button
                      className='btn btn-primary'
                      data-kt-users-modal-action='submit' // onClick={async () => await functionLogin()
                    >
                      <FacebookLogin
                        appId="1701216940365266"
                        onSuccess={(response) => {
                          console.log('Login Success!', response);
                        }}
                        onFail={(error) => {
                          console.log('Login Failed!', error);
                        }}
                        onProfileSuccess={(response) => {
                          console.log('Get Profile Success!', response);
                        }}

                      />
                    </button>
                  </div>
                }
                {(formik.values.type == 7) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked Instagram Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Hashtag to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several hashtag(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 8)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Youtube Channel Id')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Youtube Channel Id')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 9)) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Subreddit Name')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Subreddit Name')}
                            {...formik.getFieldProps('searchQuery')}
                          />
                          {formik.touched.searchQuery && formik.errors.searchQuery && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Queries to search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 10)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Instagram Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Instagram Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.type == 11) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Blocked TikTok Usernames')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several username(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryExceptionList')}
                            onChange={(searchQueryExceptionList) => formik.setFieldValue('searchQueryExceptionList', searchQueryExceptionList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryExceptionList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("You must add at least one username to block the search. You must enter your own username. Usernames must be at least 3 letters and contain only lowercase letters, numbers and _")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Hashtag to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several hashtag(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.type == 12)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('TikTok Username')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('TikTok Username')}
                          {...formik.getFieldProps('searchQuery')}
                        />
                        {formik.touched.searchQuery && formik.errors.searchQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.type == 3 || formik.values.type == 5) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Url to search')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Url to search')}
                          {...formik.getFieldProps('searchUrl')}
                        />
                        {formik.touched.searchUrl && formik.errors.searchUrl && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchUrl}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }

                {((formik.values.type == 2) || (formik.values.type == 3) || (formik.values.type == 5) || (formik.values.type == 7) || (formik.values.type == 8) || (formik.values.type == 9) || (formik.values.type == 10) || (formik.values.type == 11) || (formik.values.type == 12)) &&
                  <div className='col-lg-8 fv-row'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isAutoSearch')}
                        checked={formik.values.isAutoSearch}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isAutoSearch'>
                        {LanguageHelp('I want daily data collection.')}
                      </label>
                    </div>
                    {formik.touched.isAutoSearch && formik.errors.isAutoSearch && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.isAutoSearch}</div>
                      </div>
                    )}
                  </div>
                }

                {((formik.values.type == 2) || (formik.values.type == 3) || (formik.values.type == 5) || (formik.values.type == 7) || (formik.values.type == 8) || (formik.values.type == 9) || (formik.values.type == 10) || (formik.values.type == 11) || (formik.values.type == 12)) &&
                  <div>
                    <div className='col-lg-8 fv-row'>
                      <br></br>
                      <div className='form-check form-check-solid fv-row'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          {...formik.getFieldProps('isCompetitor')}
                          checked={formik.values.isCompetitor}
                          onChange={formik.handleChange}
                        />
                        <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isCompetitor'>
                          {LanguageHelp('This is a competitor channel.')}
                        </label>
                      </div>
                      {formik.touched.isCompetitor && formik.errors.isCompetitor && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.isCompetitor}</div>
                        </div>
                      )}
                    </div>

                    {(formik.values.isCompetitor == true) &&
                      <div className='fv-row mb-7 mt-7'>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Competitor Name')}</label>
                          <div className='col-lg-8 fv-row'>
                            <input
                              placeholder={LanguageHelp('Competitor Name')}
                              {...formik.getFieldProps('competitorName')}
                              type='text'
                              name='competitorName'
                              className={clsx('form-control form-control-lg form-control-solid')}
                              autoComplete='off'
                              disabled={formik.isSubmitting}
                            />
                            {formik.touched.competitorName && formik.errors.competitorName && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  <span role='alert'>{formik.errors.competitorName}</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }

                {(formik.values.type == 6) &&

                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Expiration Time')}</label>
                    <div className='col-lg-8 fv-row'>
                      <select
                        className='form-select form-select-solid form-select-lg'
                        {...formik.getFieldProps('expirationTime')}
                        onChange={formik.handleChange}
                      >
                        <option value='1 month'>{LanguageHelp('1 month')}</option>
                        <option value='3 month'>{LanguageHelp('3 month')}</option>
                        <option value='6 month'>{LanguageHelp('6 month')}</option>
                        <option value='1 year'>{LanguageHelp('1 year')}</option>
                        <option value='2 year'>{LanguageHelp('2 year')}</option>
                        <option value='3 year'>{LanguageHelp('3 year')}</option>
                      </select>
                    </div>
                  </div>
                }


              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  <i className="fas fa-paper-plane"></i>
                  <span className='indicator-label'>{LanguageHelp('Submit')}</span>
                  {(formik.isSubmitting) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
          </div>
        </div></div>
    </div>
  )
}

export { ChannelCreateModal }
